import type { HostContract } from '@tsagko/label-contracts'
import { createOperationContract } from './operations'
import { createResourceContract } from './resources'
import type { EmbeddedTransport } from './transport'

export interface EmbeddedAdapterOptions {
  transport: EmbeddedTransport
}

export function createEmbeddedAdapter(options: EmbeddedAdapterOptions): HostContract {
  const resources = createResourceContract(options.transport)
  return {
    resources,
    operations: createOperationContract(options.transport, resources),
  }
}

export type { EmbeddedTransport }
